import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWarehouseMaster,
  fetchConfigureWarehouseList,
  addConfigureWarehouse,
  deleteConfigureWarehouse,
  updateConfigureWarehouse,
} from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  configureList: any[];
  configureLoading: boolean;
  configureError: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  configureList: [],
  configureLoading: false,
  configureError: null,
};

const ProjectManagerManpowerSlice = createSlice({
  name: "ProjectManagerManpower",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchWarehouseMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fetch ProjectManager Manpower  List";
      })
      // Configure Warehouse thunks
      .addCase(fetchConfigureWarehouseList.pending, (state) => {
        state.configureLoading = true;
        state.configureError = null;
      })
      .addCase(fetchConfigureWarehouseList.fulfilled, (state, action) => {
        state.configureLoading = false;
        state.configureList = action.payload.data || [];
      })
      .addCase(fetchConfigureWarehouseList.rejected, (state, action) => {
        state.configureLoading = false;
        state.configureError = action.error.message || "Failed to fetch configurations";
      })
      .addCase(addConfigureWarehouse.pending, (state) => {
        state.configureLoading = true;
        state.configureError = null;
      })
      .addCase(addConfigureWarehouse.fulfilled, (state, action) => {
        state.configureLoading = false;
        // Add the new item to the list
        if (action.payload) {
          state.configureList = [...state.configureList, action.payload];
        }
      })
      .addCase(addConfigureWarehouse.rejected, (state, action) => {
        state.configureLoading = false;
        state.configureError = action.error.message || "Failed to add configuration";
      })
      .addCase(deleteConfigureWarehouse.pending, (state) => {
        state.configureLoading = true;
        state.configureError = null;
      })
      .addCase(deleteConfigureWarehouse.fulfilled, (state, action) => {
        state.configureLoading = false;
        // Remove the deleted item from the list
        state.configureList = state.configureList.filter(
          (item: any) => item.id !== action.payload.id
        );
      })
      .addCase(deleteConfigureWarehouse.rejected, (state, action) => {
        state.configureLoading = false;
        state.configureError = action.error.message || "Failed to delete configuration";
      })
      .addCase(updateConfigureWarehouse.pending, (state) => {
        state.configureLoading = true;
        state.configureError = null;
      })
      .addCase(updateConfigureWarehouse.fulfilled, (state) => {
        state.configureLoading = false;
        // Update successful, list will be refreshed
      })
      .addCase(updateConfigureWarehouse.rejected, (state, action) => {
        state.configureLoading = false;
        state.configureError = action.error.message || "Failed to update configurations";
      });
  },
});

export default ProjectManagerManpowerSlice.reducer;
